// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image_CBc2m {
  background-repeat: no-repeat;
  background-size: contain;
  height: 200px;
  width: 200px;
  background-position: 50% 50%;
}

.block_RzUKl {
  opacity: 0.1 !important;
}

.block_RzUKl:hover {
  opacity: 1;
}

.propertyGrid_ecGTc {
  --size-padMedium:2px;
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/stationTimeline/LinearViewBlock.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,aAAa;EACb,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB","sourcesContent":[".image {\n  background-repeat: no-repeat;\n  background-size: contain;\n  height: 200px;\n  width: 200px;\n  background-position: 50% 50%;\n}\n\n.block {\n  opacity: 0.1 !important;\n}\n\n.block:hover {\n  opacity: 1;\n}\n\n.propertyGrid {\n  --size-padMedium:2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"image": `image_CBc2m`,
	"block": `block_RzUKl`,
	"propertyGrid": `propertyGrid_ecGTc`
};
export default ___CSS_LOADER_EXPORT___;
